import { ObjectForSelection } from '../types/interfaces/ObjectForSelection';

export const ObjectForSelectionTemplate: ObjectForSelection = {
  id: 0,
  label: ''
};
